import React from "react"
import { useFormState } from "react-hook-form"

type SectionErrorContextType = {
  registerFieldLocation: (fieldName: string, sectionKey: string) => void
  // fieldSectionMap: Record<sddtring, Array<string>>
  sectionErrors: Set<string>
}

const SectionErrorContext = React.createContext<SectionErrorContextType>({
  registerFieldLocation: () => {},
  sectionErrors: new Set(),
  // fieldSectionMap: {},
})

function getErrorPaths(errors: any, path = "") {
  let paths: string[] = []

  for (const key in errors) {
    const value = errors[key]
    const currentPath = path ? `${path}.${key}` : key

    if (value && typeof value === "object") {
      if ("message" in value || "type" in value) {
        paths.push(currentPath)
      } else {
        paths = paths.concat(getErrorPaths(value, currentPath))
      }
    }
  }

  return paths
}

export function SectionErrorProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [fieldSectionMap, setFieldSectionMap] = React.useState<
    Record<string, Array<string>>
  >({})

  const registerFieldLocation = React.useCallback(
    (fieldName: string, sectionKey: string) => {
      setFieldSectionMap((prevMap) => ({
        ...prevMap,
        [fieldName]: [...(prevMap[fieldName] || []), sectionKey],
      }))
    },
    [setFieldSectionMap],
  )
  const { errors } = useFormState()
  const errorPaths = getErrorPaths(errors)

  const sectionErrors = React.useMemo(() => {
    const errors = errorPaths.flatMap(
      (errorPath) => fieldSectionMap[errorPath] || [],
    )
    return new Set(errors)
  }, [errorPaths, fieldSectionMap])

  return (
    <SectionErrorContext.Provider
      value={{ registerFieldLocation, sectionErrors }}
    >
      {children}
    </SectionErrorContext.Provider>
  )
}

export function useSectionErrors() {
  return React.useContext(SectionErrorContext)
}
